import { BodyText, Divider, Flex } from '@utilitywarehouse/hearth-react';

import './styles.scss';

export const Terms = () => (
  <Flex direction="column" className="terms">
    <Divider marginBottom="150" className="terms__divider" />
    <BodyText className="terms__copy">T&amp;C's apply</BodyText>
  </Flex>
);
